import { Controller } from "@hotwired/stimulus"

// Croix de reset (×) GÉNÉRIQUE pour n'importe quelle barre de recherche.
// S'attache directement sur l'<input> : injecte un bouton × dans le parent, le
// positionne sur le bord droit de l'INPUT (via sa géométrie offsetLeft/Width →
// marche quel que soit le markup : pill, wrapper, input nu). Affiché dès qu'il y a
// du texte ; au clic vide + refocus + redéclenche `input` (relance le filtre/fetch).
// Application = un seul attribut data-controller="clearable-input" sur l'input.
export default class extends Controller {
  connect() {
    const parent = this.element.parentElement
    if (parent && getComputedStyle(parent).position === "static") {
      parent.style.position = "relative"
    }

    this.button = document.createElement("button")
    this.button.type = "button"
    this.button.className = "clearable-x"
    this.button.setAttribute("aria-label", "Effacer la recherche")
    this.button.innerHTML = "&times;"
    this.button.addEventListener("click", this.clear)
    parent?.appendChild(this.button)

    this.element.style.paddingRight = "30px"
    this.element.addEventListener("input", this.onInput)
    this.reposition = this.position.bind(this)
    window.addEventListener("resize", this.reposition)
    this.position()
    this.toggle()
  }

  disconnect() {
    this.element.removeEventListener("input", this.onInput)
    window.removeEventListener("resize", this.reposition)
    this.button?.removeEventListener("click", this.clear)
    this.button?.remove()
  }

  // Place le × sur le bord droit de l'input (repère = offsetParent positionné).
  position() {
    if (!this.button) return
    const el = this.element
    const right = el.offsetLeft + el.offsetWidth
    this.button.style.left = `${right - 26}px`
    this.button.style.top = `${el.offsetTop + el.offsetHeight / 2}px`
  }

  onInput = () => this.toggle()

  toggle = () => {
    if (!this.button) return
    this.button.style.display = this.element.value ? "inline-flex" : "none"
    if (this.element.value) this.position()
  }

  clear = () => {
    this.element.value = ""
    this.toggle()
    this.element.focus()
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
